import { saveObjet } from './campana.actions'

export const saveObjets = (obj) => dispatch =>{
  dispatch(saveObjet(obj))
}